export const fiatCodes = [
    { value: 'ZAR', label: 'ZAR' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'GBP', label: 'GBP' },
]
export const timeIntervals = [
    { value: '1', label: '1 day' },
    { value: '7', label: '1 week' },
    { value: '30', label: '1 month' },
    { value: '90', label: '3 months' },
    { value: '365', label: '1 year' },
    { value: 'all', label: 'All' },
]